import { useBreadcrumb } from "core/features/breadcrumbs";
import ListaMensagens from "./components/ListaMensagens";
import Container from "components/Container";

function MensagemListagemPage() {
  useBreadcrumb([
    { name: "Administração" },
    { name: "Mensagens", url: "/administracao/mensagens" },
  ]);

  return (
    <Container>
      <ListaMensagens />
    </Container>
  );
}

export default MensagemListagemPage;
